import { isObject } from "../is/isObject.js";
const mergeDeep = (...objects) => objects.reduce((result, current) => {
  Object.keys(current).forEach((key) => {
    if (Array.isArray(result[key]) && Array.isArray(current[key])) {
      result[key] = mergeDeep.options.mergeArrays ? Array.from(new Set(result[key].concat(current[key]))) : current[key];
    } else if (isObject(result[key]) && isObject(current[key])) {
      result[key] = mergeDeep(result[key], current[key]);
    } else {
      result[key] = current[key];
    }
  });
  return result;
}, {});
const defaultOptionsType = {
  mergeArrays: false
};
mergeDeep.options = defaultOptionsType;
mergeDeep.withOptions = (options, ...objects) => {
  mergeDeep.options = {
    ...defaultOptionsType,
    ...options
  };
  const result = mergeDeep(...objects);
  mergeDeep.options = defaultOptionsType;
  return result;
};
export {
  mergeDeep
};
